const texts = {
   invalidName: "Name should have minimum 2 words and each word should contain 2 letters",
   invalidNameShare: "Please enter both first and last name",
   invalidNameError: "Please enter a valid name",
   invalidMob: "Please enter a valid phone number",
   invalidEmail: "Please enter a valid email",
   invalidEmailMob: "Please enter a valid email/mobile",
   invalidFname: "First name should have minimum 2 characters",
   invalidMname: "Middle name should have minimum 2 characters",
   invalidLname: "Last name should have minimum 2 characters",

   inviteSuccess: "Successfully invited.",
   inviteFailed: "Unable to invite.",

   smthngWentWrong: "Something went wrong, we'll look into it.",
   infoUpdateSuccessful: "Information updated successfully!",
   textSentSuccessful: "Text sent successfully!",
   referralSentSuccessful: "Patient's referral sent successfully!",
   requiredDob: "DOB required.",
   requireEmail: "Email required.",
   requirePhone: "Phone number required.",
   textMessageRequired: "Message cannot be blank.",
   requireHealthSystem: "Health system is required.",
   requirePhysician: "Physician is required.",
   textMessageMaxLength: "Note should not exceed 300 characters.",
   requireHospital: "Hospital is required.",
   requireDepartment: "Department is required.",
   permissionTitle: "Permission Required",
   permissionSubtitle: "Please allow permissions.",
};

export default texts;
